/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

/**
 * @description To check whether the array has only one element in it or not.
 * @param array The array which needs to be checked
 */

export const hasSingleItem = (array) => {
  return array && array.length === 1;
};
